import { Typography } from '@mui/material'
import Box from '@mui/material/Box'
import Button from '@mui/material/Button'
import Card from '@mui/material/Card'
import CardActions from '@mui/material/CardActions'
import CardContent from '@mui/material/CardContent'
import CircularProgress from '@mui/material/CircularProgress'
import FormControl from '@mui/material/FormControl'
import FormHelperText from '@mui/material/FormHelperText'
import Grid from '@mui/material/Grid'
import TextField from '@mui/material/TextField'
import { useEffect, useState } from 'react'
import { Controller, useForm } from 'react-hook-form'
import toast from 'react-hot-toast'
import { useNavigate, useParams } from 'react-router-dom'
import { apiService } from '../../api/axiosClient'
import Page from '../../components/Page'
import { convertURLtoFile } from '../../utils/convertURLtoFile'

const MainCategory = () => {
    const params = useParams();
    const navigate = useNavigate();
    const [category, setCategory] = useState({})
    const [loading, setLoading] = useState(false)
    const [files, setFiles] = useState([])
    const {
        control,
        handleSubmit,
        formState: { errors },
        reset,
    } = useForm()

    useEffect(() => {
        const fetchData = async () => {
            const response = await apiService.get(`/maincategory/${params.id}`)
            const payload = response.data;

            setCategory(payload.data)
        }

        fetchData().catch(e => console.error(e));
    }, [params.id]);

    useEffect(() => {
        const defaultValues = {
            title: category.title,
            subtitle: category.subtitle,
            link: category.link,
            showorder: category.showorder
        }
        reset(defaultValues)

        convertURLtoFile(category.imageUrl, setFiles)

    }, [reset, category]);

    const goBack = () => {
        // createObjectURL를 통해 만들어진 url는 해당 브라우저가 존재한 상태에서 revokeObjectURL 메소드로 url을 무효화 시키지 않으면 
        // js 엔진에서 garbage collect를 시키지 않고 계속 변수가 남아 메모리 누수가 됩니다.
        // 그렇기 때문에 url 사용을 종료하면 revokeObjectURL 메소드를 사용하여 브라우저가 
        // 더이상 이 객체를 메모리에 들고 있지 않아도 된다고 알려야합니다.
        files.map(file => (
            URL.revokeObjectURL(file)
        ))

        navigate(-1)
    }

    const onSubmit = async (data, e) => {
        setLoading(true)

        const [file] = files;
        const formData = new FormData()

        formData.append('title', data.title);
        formData.append('subtitle', data.subtitle);
        formData.append('link', data.link);
        formData.append('showorder', data.showorder);
        formData.append('file', file);

        await apiService.postFormData(`/maincategory/${category.id}`, formData)
        .then(response => {
            toast.success('수정 되었습니다')
            goBack()

        }).catch(error => {
            // 에러는 이제 axiosClient의 interceptor에서 자동으로 처리됩니다
            console.error('API Error:', error);
        }).finally(() => {
            setLoading(false)
        });
    }

    return (
        <Page title="Key Products">
            <Card>
                <form onSubmit={handleSubmit(onSubmit)} id="categoryform">
                    <CardContent sx={{ pt: 8 }}>
                        <Box sx={{ mb: 9, textAlign: 'center' }}>
                            <Typography variant='h5' sx={{ mb: 3, lineHeight: '2rem' }}>
                                Key Product
                            </Typography>
                        </Box>

                        <Grid container spacing={6}>
                            <Grid item xs={12}>
                                <FormControl fullWidth>
                                    <Controller
                                        name='title'
                                        control={control}
                                        rules={{ required: true }}
                                        defaultValue=""
                                        render={({ field: { value, onChange } }) => (
                                            <TextField
                                                value={value}
                                                label='제목'
                                                id='title'
                                                onChange={onChange}
                                                placeholder='제목을 입력해주세요'
                                                error={Boolean(errors.title)}
                                                aria-describedby='validation-async-title'
                                                variant="standard"
                                            />
                                        )}
                                    />
                                    {errors.title && (
                                        <FormHelperText sx={{ color: 'error.main' }} id='validation-async-title'>
                                            필수
                                        </FormHelperText>
                                    )}
                                </FormControl>
                            </Grid>

                            <Grid item xs={12}>
                                <FormControl fullWidth>
                                    <Controller
                                        name='subtitle'
                                        control={control}
                                        rules={{ required: true }}
                                        defaultValue=""
                                        render={({ field: { value, onChange } }) => (
                                            <TextField
                                                value={value}
                                                label='부제목'
                                                id='subtitle'
                                                onChange={onChange}
                                                placeholder='부제목을 입력해주세요'
                                                error={Boolean(errors.subtitle)}
                                                aria-describedby='validation-async-subtitle'
                                                variant="standard"
                                            />
                                        )}
                                    />
                                    {errors.subtitle && (
                                        <FormHelperText sx={{ color: 'error.main' }} id='validation-async-subtitle'>
                                            필수
                                        </FormHelperText>
                                    )}
                                </FormControl>
                            </Grid>

                            <Grid item xs={12} md={6}>
                                <FormControl fullWidth>
                                <Controller
                                    name='link'
                                    control={control}
                                    rules={{ required: true }}
                                    defaultValue=""
                                    render={({ field: { value, onChange } }) => (
                                    <TextField
                                        value={value}
                                        label='URL'
                                        id='link'
                                        onChange={onChange}
                                        placeholder='URL 링크를 입력해주세요'
                                        error={Boolean(errors.subtitle)}
                                        aria-describedby='validation-async-link'
                                        variant="standard"
                                    />
                                    )}
                                />
                                {errors.link && (
                                    <FormHelperText sx={{ color: 'error.main' }} id='validation-async-link'>
                                    필수
                                    </FormHelperText>
                                )}
                                </FormControl>
                            </Grid>

                            <Grid item xs={12} md={6}>
                                <FormControl fullWidth>
                                <Controller
                                    name='showorder'
                                    control={control}
                                    rules={{ required: true }}
                                    defaultValue=""
                                    render={({ field: { value, onChange } }) => (
                                    <TextField
                                        value={value}
                                        label='순서'
                                        id='showorder'
                                        onChange={onChange}
                                        placeholder='순서를 입력해주세요'
                                        error={Boolean(errors.subtitle)}
                                        aria-describedby='validation-async-showorder'
                                        variant="standard"
                                    />
                                    )}
                                />
                                {errors.showorder && (
                                    <FormHelperText sx={{ color: 'error.main' }} id='validation-async-showorder'>
                                    필수
                                    </FormHelperText>
                                )}
                                </FormControl>
                            </Grid>
                        </Grid>
                    </CardContent>
                </form>

                <CardActions className='card-action'>
                    <Button type="submit" form="categoryform" variant='contained'>
                        {loading ? (
                            <CircularProgress
                                sx={{
                                    color: 'common.white',
                                    width: '20px !important',
                                    height: '20px !important',
                                    mr: theme => theme.spacing(2)
                                }}
                            />
                        ) : null}
                        수정
                    </Button>
                    <Button variant='outlined' color='secondary' onClick={goBack}>
                        취소
                    </Button>
                </CardActions>
            </Card>
        </Page>
    )
}

export default MainCategory